import React from 'react';
import TableArrangementApp from './components/TableArrangementApp';
import SessionExpiryNotice from './components/SessionExpiryNotice/SessionExpiryNotice';
import ToastNotification from './components/ToastNotification/ToastNotification';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { useI18n } from './i18n/I18nContext';

const AppContent: React.FC = () => {
  const { t } = useI18n();
  const { auth, loading, backendReachable } = useAuth();
  const [toastOpen, setToastOpen] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('');
  const [toastSeverity, setToastSeverity] = React.useState<'success' | 'error' | 'warning' | 'info'>('info');

  function showToast(message: string, severity: 'success' | 'error' | 'warning' | 'info' = 'info') {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  }

  if (typeof window !== 'undefined' && window.location.pathname === '/reset-password') {
    return (
      <>
        <ResetPasswordPage showToast={showToast} />
        <ToastNotification
          open={toastOpen}
          message={toastMessage}
          severity={toastSeverity}
          onClose={() => setToastOpen(false)}
        />
      </>
    );
  }

  if (loading) {
    return (
      <div style={{ padding: '2rem' }}>
        {t('app.loadingApp')}
      </div>
    );
  }

  const shouldShowLogin =
    !backendReachable ||
    auth?.authExpired ||
    !auth?.authenticated;

  if (shouldShowLogin) {
    return (
      <>
        <LoginPage showToast={showToast} />
        <ToastNotification
          open={toastOpen}
          message={toastMessage}
          severity={toastSeverity}
          onClose={() => setToastOpen(false)}
        />
      </>
    );
  }

  return (
    <>
      <TableArrangementApp />
      <SessionExpiryNotice />
      <ToastNotification
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </>
  );
};

const App: React.FC = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
